var map = {
	"./gallery-wip-pommel_00.jpg": 2796,
	"./gallery-wip-pommel_01.jpg": 2797,
	"./gallery-wip-pommel_02.jpg": 2798,
	"./gallery-wip-pommel_03.jpg": 2799,
	"./gallery-wip-pommel_04.jpg": 2800,
	"./gallery-wip-pommel_05.jpg": 2801,
	"./gallery-wip-pommel_06.jpg": 2802,
	"./gallery-wip-pommel_07.jpg": 2803,
	"./gallery_00.jpg": 2804,
	"./gallery_01.jpg": 2805,
	"./gallery_02.jpg": 2806,
	"./gallery_03.jpg": 2807,
	"./gallery_04.jpg": 2808,
	"./gallery_05.jpg": 2809,
	"./gallery_06.jpg": 2810,
	"./gallery_07.jpg": 2811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2795;